export default __webpack_public_path__ + "a2a0d5c7a042c881cc718f7db350358a.png";